import { CollaboratorsPage, RoleplayProvider } from '@hub-la/fe-roleplay'

export const Collaborators = () => {
  return (
    <RoleplayProvider>
      <CollaboratorsPage />
    </RoleplayProvider>
  )
}
